export default "__VITE_PUBLIC_ASSET__720840ef__"